/**
 * 为没有 Verified 标记的 Judge.me 评论
 * 补充与当前 Circooter 页面一致的原生 Buyer Badge 结构。
 */
(() => {
  const WIDGET_SELECTOR = '#judgeme_product_reviews';
  const REVIEW_SELECTOR = '.jdgm-rev';
  const AUTHOR_SELECTOR = '.jdgm-rev__author';
  const BADGE_SELECTOR = '.jdgm-rev__buyer-badge';
  const BADGE_WRAPPER_SELECTOR = '.jdgm-rev__buyer-badge-wrapper';
  const READY_ATTRIBUTE = 'data-custom-verified-ready';

  function createBadge() {
    const wrapper = document.createElement('span');
    wrapper.className = 'jdgm-rev__buyer-badge-wrapper';

    const badge = document.createElement('span');
    badge.className = 'jdgm-rev__buyer-badge';

    wrapper.appendChild(badge);

    return wrapper;
  }

  function addBadge(review) {
    if (!(review instanceof Element)) return;

    const author = review.querySelector(AUTHOR_SELECTOR);
    if (!author) return;

    // Judge.me 根据该属性显示头像右下角的验证勾。
    if (review.getAttribute('data-verified-buyer') === 'false') {
      review.setAttribute('data-verified-buyer', 'true');
    }

    // 图片详情弹框使用另一套结构：badge 必须直接放在作者后面，
    // 不能套用列表卡片中的 buyer-badge-wrapper。
    if (review.closest('.jm-mfp-review-wrapper')) {
      const profile = author.closest('.jdgm-row-profile');
      if (!profile) return;

      const directBadge = Array.from(profile.children).find((element) =>
        element.matches(BADGE_SELECTOR)
      );

      if (directBadge) {
        // 原生结构在作者与 badge 之间包含空白文本，保留相同间距。
        if (directBadge.previousSibling === author) {
          profile.insertBefore(document.createTextNode(' '), directBadge);
        }
        return;
      }

      profile
        .querySelectorAll(BADGE_WRAPPER_SELECTOR)
        .forEach((wrapper) => wrapper.remove());

      const badge = document.createElement('span');
      badge.className = 'jdgm-rev__buyer-badge';
      author.after(document.createTextNode(' '), badge);
      return;
    }

    // 已有 Judge.me 原生 Verified 标记时不再添加。
    if (review.querySelector(BADGE_SELECTOR)) return;

    // 清理可能存在但内容不完整的 wrapper。
    review
      .querySelectorAll(BADGE_WRAPPER_SELECTOR)
      .forEach((wrapper) => wrapper.remove());

    // 插入位置与原生 Judge.me 结构一致：
    // .jdgm-rev__author 后面、同一个 author wrapper 内。
    author.insertAdjacentElement('afterend', createBadge());
  }

  function decorateReviews(root) {
    if (!(root instanceof Element)) return;

    const parentReview = root.closest(REVIEW_SELECTOR);
    if (parentReview) {
      addBadge(parentReview);
    }

    if (root.matches(REVIEW_SELECTOR)) {
      addBadge(root);
    }

    root.querySelectorAll(REVIEW_SELECTOR).forEach(addBadge);
  }

  function initialise() {
    const widget = document.querySelector(WIDGET_SELECTOR);

    if (!widget || widget.hasAttribute(READY_ATTRIBUTE)) return;

    widget.setAttribute(READY_ATTRIBUTE, 'true');
    decorateReviews(widget);

    // 监听分页、排序、筛选等造成的评论重新渲染。
    const widgetObserver = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            decorateReviews(node);
          }
        });
      });
    });

    widgetObserver.observe(widget, {
      childList: true,
      subtree: true
    });

    // Judge.me 图片弹窗可能挂载到评论组件之外。
    const popupObserver = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            decorateReviews(node);
          }
        });
      });
    });

    popupObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function waitForWidget() {
    if (document.querySelector(WIDGET_SELECTOR)) {
      initialise();
      return;
    }

    const pageObserver = new MutationObserver(() => {
      if (!document.querySelector(WIDGET_SELECTOR)) return;

      pageObserver.disconnect();
      initialise();
    });

    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForWidget, {
      once: true
    });
  } else {
    waitForWidget();
  }
})();
